import FallbackImage from '../../../assets/imageFallback-6ecc21de.svg';
import { SpinTheWheelSvg } from './components/SpinTheWheelSvg.js';
import { jsx } from 'react/jsx-runtime';

/**
 * When adding new SVGs to this registry, convert your SVG to JSX first.
 * SVG attributes need to be converted to their React/JSX equivalents:
 * - stroke-width becomes strokeWidth
 * - class becomes className
 * - etc.
 *
 * Recommended tools:
 * - https://svg2jsx.com
 * - https://react-svgr.com/playground
 */
const svgRegistry = {
  'spin-the-wheel': SpinTheWheelSvg
  // Add other SVGs here
};
const getSvg = (name, config = {}) => {
  if (!name || !(name in svgRegistry)) {
    return /*#__PURE__*/jsx("img", {
      src: FallbackImage,
      alt: "fallback"
    });
  }
  const Component = svgRegistry[name];
  return Component(config);
};
function Svg({
  svgElementName,
  svgHeadline
}) {
  const svg = getSvg(svgElementName, {
    headline: svgHeadline
  });
  return svg;
}
export { Svg, getSvg };
//# sourceMappingURL=Svg.js.map
